module.exports = {"510727100":"龙安镇","510727101":"古城镇","510727103":"响岩镇","510727107":"大桥镇","510727108":"水晶镇","510727109":"江油关镇","510727200":"高村乡","510727202":"坝子乡","510727206":"锁江羌族乡","510727207":"土城藏族乡","510727208":"旧堡羌族乡","510727209":"阔达藏族乡","510727210":"黄羊关藏族乡","510727211":"虎牙藏族乡","510727212":"泗耳藏族乡","510727213":"白马藏族乡","510727214":"木座藏族乡","510727215":"木皮藏族乡","510727216":"豆叩羌族乡","510727217":"平通羌族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510727.json
// module id = 2438
// module chunks = 0